import { createSelector } from 'reselect';
import { AppState } from '../..';

// NOTE: Doing it this way with an additional argument destroy the memoization? If so, how do we type...
export const getPartnerBySlug = (slug: string) =>
  createSelector(
    (state: AppState) => state.partners.partners,
    (partners) => partners[slug],
  );

export const getAllPartners = createSelector(
  (state: AppState) => state.partners.partners,
  (partners) => Object.values(partners),
);
